module.exports = __webpack_public_path__ + "img/order-list@2x.e8e500f2.png";